<template>
<div>
  <v-row>
    <v-col cols=12>
<strong>{{$t('typeOfJourneyTitle')}}</strong>
    </v-col>
        <v-col cols=12>
<p>{{$t('typeOfJourneyDescription')}}</p>
    </v-col>
  </v-row>
    <v-row>
    <v-col cols=12>
    <v-radio-group  @change="setJourneyUnorderedOrOrdered(isUnorderedOrOrdered)" v-model="isUnorderedOrOrdered" class="switch-field2" row
      active-class="active2">
      <v-radio id="radio-two" name="all" :label="$t('Unordered')" :value="false" ></v-radio>
      <v-radio id="radio-one" name="nearMe" :label="$t('Ordered')" :value="true" >
      </v-radio>
    </v-radio-group>
    </v-col>
    </v-row>
</div>
</template>

<script>
//this page is displayed when an error occurs

export default {
  name: 'selectJourneyUnorderedOrOrdered',
  components: {
  },
  data() {
    return {
      isUnorderedOrOrdered:false
    }
  },
    computed: {
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    cacheJourney: {
      get: function () {
        return this.$store.getters.getNewJourneys
      }
    }

  },
  mounted(){
    if(this.cacheJourney.isPublic){
      this.isUnorderedOrOrdered=this.cacheJourney.isPublic
    }
  },
  methods: {

setJourneyUnorderedOrOrdered:function () {
  this.$store.dispatch('setJourneyUnorderedOrOrdered', this.isUnorderedOrOrdered)
},
        goToLogin: function () {
            this.$router.push("/");
        }
  }
}
</script>
<style>
.v-input.switch-field2.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div,
.v-input.switch-field3.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div{
  background-color: #e5e5e5;
  border-radius: 99rem;
}
.switch-field2.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
/*switch btn all  - nearMe*/
.switch-field3,.switch-field2 {

	color: rgba(0, 0, 0, 0.6);
	display: flex;

	overflow: hidden;
}

.switch-field3 input,.switch-field2 input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}

.switch-field3 label,.switch-field2 label {
  width: 50%;

	/*background-color: #e5e5e5;
	color: rgba(0, 0, 0, 0.6);*/
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 4px 0px;
	/*border: 1px solid rgba(0, 0, 0, 0.2);*/
	/*box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);*/
	transition: all 0.1s ease-in-out;
}

.switch-field3 label:hover,.switch-field2 label:hover {
	cursor: pointer;
}

.switch-field3 input:checked + label,.switch-field2 input:checked + label {
	background-color: #000;
  color:#FFF;
  border-radius: 99rem;
	box-shadow: none;
}

.switch-field3 label:first-of-type,.switch-field2 label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.v-radio.theme--light > label{
  margin-left: auto;
  margin-right: auto;
}
.theme--light.v-label{
  color: #38737A;
}
.active2,.active3{
  background-color: #38737A;
  border-radius: 999rem;
}





.v-input--selection-controls {
    padding-top: 0px !important;
}
.v-input.switch-field2.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div,
.v-input.switch-field3.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot > div{
  background-color: #e5e5e5;
  border-radius: 99rem;
}

.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
}
.v-input__slot{
  margin-bottom: 0px;
}
/* v-radio btn 1*/
.theme--light.v-label{
  color: black;
}

.v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: auto;
    margin-left: auto;
    width: 48%;
    text-align: center;
}
.v-input--radio-group.v-input--radio-group--row .v-radio > .v-label{
  padding: auto auto;
  text-align: center;
}
.switch-field1 .v-radio .active1 label{
  background-color: #81B9BF;
  border-radius: 99rem!important;
}
.active1 {
  color:#38737A;
  border-radius: 999rem;
}
.active2,.active3{
  background-color: #38737A;
  border-radius: 999rem;
}
div.v-radio.theme--light.active3 > label,div.v-radio.theme--light.active2 > label{
    color: white!important;
}
.switch-field1.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;

}
.switch-field2.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
.switch-field3.v-input--radio-group.v-input--radio-group--row .v-radio{
  margin-right: auto;
  margin-left: auto;
  padding: 0px 5vh;

}
.v-input.switch-field1.theme--light.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row > div > div.v-input__slot.white > div > div.v-radio.theme--light > div{
  display: none;
}
.v-application--is-ltr .v-input--selection-controls__input {
    display: none;
}

/* end v-radio btn */
.v-tab--disabled {
    pointer-events: none;
    opacity: 1;
}
.v-btn--fab.v-size--x-large {
    height: 100px;
    width: 100px;
}
.rounded-circle{
  border-radius: 50%;
  padding: 10%;
}
.rounded-circle span{
white-space: inherit;
}
.w3-badge{
  border-radius: 50%;
    background-color: gray;
    color: #fff;
    display: inline-block;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    text-align: center;
    line-height: 1.5rem;
}
.border-bottom-grey{
  border-bottom: 1px solid gray;
}
.styleimgthumbnails{
max-width: 90%;
}
.ctadashboard{
  text-transform: capitalize;
}
.ctareadMore{
    text-transform: capitalize;
    color:#AAA
}
.styleimgheritageFull{
  width: 40%;
}
.titleHeritrage{
  text-transform: capitalize;
  font-size: 1rem;;
}
.containerimgsingleStory {
  position: relative;
  text-align: center;
}
.image-inner-container {
    position: absolute;
}
.overlay {
    position: absolute;
    text-align: center;
    width: 100%;
}

.v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  justify-content: center
}


/*switch btn Create - view*/
.switch-field1{
	display: flex;
	margin-bottom: 0%;
	overflow: hidden;
}

.switch-field1 input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}

.switch-field1 label :not(.active1){
    background-color: #38737A;
}
.switch-field1 label {
  border-radius: 999rem;
  border: 2px solid transparent;
  width: 50%;
	color: rgba(0, 0, 0, 1);
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 4px 0px;
	/*margin-right: -1px;*/
	/*border: 1px solid rgba(0, 0, 0, 0.2);*/
	/*box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);*/
	transition: all 0.1s ease-in-out;
}

.switch-field1 label:hover {
	cursor: pointer;
}

.switch-field1 input:checked + label {

	border: 2px solid black;
  border-radius: 99rem;
	box-shadow: none;
}

.switch-field1 label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.switch-field1 label:last-of-type {
	border-radius: 0 4px 4px 0;
}

/*switch btn saved  - Published*/

/*switch btn all  - nearMe*/
.switch-field3,.switch-field2 {

	color: rgba(0, 0, 0, 0.6);
	display: flex;

	overflow: hidden;
}

.switch-field3 input,.switch-field2 input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}

.switch-field3 label,.switch-field2 label {
  width: 50%;

	/*background-color: #e5e5e5;
	color: rgba(0, 0, 0, 0.6);*/
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 4px 0px;
	/*border: 1px solid rgba(0, 0, 0, 0.2);*/
	/*box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);*/
	transition: all 0.1s ease-in-out;
}

.switch-field3 label:hover,.switch-field2 label:hover {
	cursor: pointer;
}

.switch-field3 input:checked + label,.switch-field2 input:checked + label {
	background-color: #000;
  color:#FFF;
  border-radius: 99rem;
	box-shadow: none;
}

.switch-field3 label:first-of-type,.switch-field2 label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.v-radio.theme--light > label{
  margin-left: auto;
  margin-right: auto;
}
.theme--light.v-label{
  color: #38737A;
}















</style>

